import React from 'react';
import '../styles/ContactForm.css';
import contactImage from '../Assets/Images/contact-img.png'; // Ensure the path is correct
import logo from '../Assets/Images/Akij-Insaf-logo.JPG';

function ContactForm() {
  return (
    <div className="contactf-container">
      <div className="contactf-wrapper">
        {/* Left: Image */}
        

        {/* Right: Content & Form */}
        <div className="contactf-content">
          <h2>Want to talk with us?</h2>
          <p>
            Have question in mind? Want to know more about our company or give report just fill up below form we will get touch with you as soon as possible.
          </p>
          <form className="contactf-form">
            <label htmlFor="name">Name: <span className="required">*</span></label>
            <input type="text" id="name" placeholder="Enter Your Name" required />

            <label htmlFor="email">Email: <span className="required">*</span></label>
            <input type="email" id="email" placeholder="Enter Your Email" required />

            <label htmlFor="subject">Subject: <span className="required">*</span></label>
            <input type="text" id="subject" placeholder="Enter Your Subject" required />

            <label htmlFor="message">Message: <span className="required">*</span></label>
            <textarea id="message" placeholder="Enter Your Message" required></textarea>

            <button type="submit">Submit</button>
          </form>
        </div>
        <div className="contactf-image">
          <img src={logo} alt="logo" className="contactf-logo" />
          <img src={contactImage} alt="Contact Us" className="contactf-img" />
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
